/**
 * A sale's or an invoice's number as printed and shown: zero-padded, so
 * numbers line up and sort as text, e.g. 000123.
 */
export const documentNumber = (number?: number | null) =>
	number === null || number === undefined
		? ""
		: String(number).padStart(6, "0");
